import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { I360Service } from 'src/Services/i360Service';
import { FilterModel } from 'src/Models/filterModel';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { SpecialReportModel, SpecialReportSectionsModel } from 'src/Models/SpecialReportModel';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { DomSanitizer } from '@angular/platform-browser';
import * as DOMPurify from 'dompurify';

declare var $: any;

@Component({
  selector: 'app-special-briefing-report',
  templateUrl: './special-briefing-report.component.html',
  styleUrls: ['./special-briefing-report.component.css']
})
export class SpecialBriefingReportComponent implements OnInit, AfterViewInit, OnDestroy {
  listOfSpecialReport: SpecialReportModel[];
  filterModel = new FilterModel();
  tokenKey: string = '';
  specialReportSectionDetails: any = [];
  _userID: any;

  currentPage: number = 1;
  totalRecordCount: number = -1;
  keywordFilter: string = '';
  OrderBy: string = '';
  isAscending: boolean = false
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  videoURL: any;
  videoType: string;
  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  @ViewChild("videoModel", { static: false }) videoModel: ElementRef;
  @ViewChild("specialBriefingVideoModal", { static: false }) specialBriefingVideoModal: ElementRef;
  topicTitle: string = '';
  isEmbed: boolean = false;
  listOfSpecialReportSection: SpecialReportSectionsModel[];
  groupArr: any[];
  isloading: boolean = false;

  constructor(private readonly i360Service: I360Service,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly appActivity: ApplicationActivityService,
    private readonly sanitizer: DomSanitizer,
    private readonly ngZone: NgZone) {
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this._userID = sessionStorage.getItem('UserId');
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '500';
    this.filterModel.orderBy = 'SectionSortOrder,SortOrder';
    this.filterModel.userID = this._userID;
    this.filterModel.productId = ToolEnum.specialReport;
    this.titleService.setTitle('Special Report | JSi360');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.Geti360SpecialReport();
  }

  ngAfterViewInit() {
    $(this.specialBriefingVideoModal.nativeElement).on('hidden.bs.modal.specialBriefing', () => {
      this.ngZone.run(() => this.unloadVideoPlayer());
    });
  }

  ngOnDestroy() {
    if (this.specialBriefingVideoModal && this.specialBriefingVideoModal.nativeElement) {
      $(this.specialBriefingVideoModal.nativeElement).off('hidden.bs.modal.specialBriefing');
    }
  }

  Geti360SpecialReport() {
    this.isloading = true;
    this.i360Service.i360SpecialReportGetFront(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        this.specialReportSectionDetails = data['listOfSpecialReport'];

        this.groupArr = this.specialReportSectionDetails.reduce((r, { sectionName }) => {
          if (!r.some(o => o.sectionName == sectionName)) {
            r.push({ sectionName, groupItem: this.specialReportSectionDetails.filter(v => v.sectionName == sectionName) });
          }
          return r;
        }, []);

        if (this.specialReportSectionDetails != null) {
          if (this.specialReportSectionDetails.length > 0) {
            this.totalRecordCount = this.specialReportSectionDetails[0].totalRecordCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
        else {
          this.totalRecordCount = 0;
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  donwloadFile(data: SpecialReportModel) {
    this.topicTitle = '';
    this.isEmbed = data.isEmbed;
    if ((!data.docPath || data.isLocked) && !data.isEmbed)
      return;

    if (data.isLocked)
      return;

    this.topicTitle = data.title;
    if (data.linktype == 1 || data.linktype == 0) {
      if (data.isEmbed) {
        ApplicationActivityStore('View', 'Special Report', this.appActivity, data.specialReportId, ActionActivity['Special Report'], data.title);
        if (data.externalURL.includes('youtube')) {
          this.videoURL = data.externalURL;
          const cleanURL = DOMPurify.sanitize(data.externalURL);
          this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(cleanURL);
          this.videoModel.nativeElement.click();
        }
        else {
          window.open(data.externalURL, '_blank');
        }
      }
    }

    else if (data.linktype == 2) {
      const extension = data.docPath.split(".").pop();
      if (extension == 'ogg' || extension == 'ogv' || extension == 'mp4' || extension == 'webm') {
        ApplicationActivityStore('View', 'Special Report', this.appActivity, data.specialReportId, ActionActivity['Special Report'], data.title);
        this.videoType = 'video/' + extension;
        const cleanURL = DOMPurify.sanitize(data.docPath);
        this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(cleanURL);
        this.videoModel.nativeElement.click();
        const player = this.videoplayer ? this.videoplayer.nativeElement : null;
        if (player && typeof player.load === 'function') {
          player.load();
          player.play();
        }
      }
      else {
        ApplicationActivityStore('Download', 'Special Report', this.appActivity, data.specialReportId, ActionActivity['Special Report'], data.displayDocName)
        this.isShowprogressSpinner = true;
        this.blockedDocument = true;
        this.i360Service.DownloadDocument(this.tokenKey, { DocType: 'specialreport', DocPath: data.docPath }).subscribe(
          fileData => {
            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
            if (fileData != null) {
              FileSaver.saveAs(fileData, data.displayDocName);
              this.toastr.success('File downloaded successfully', 'File Downloaded')
            }
          }, error => {
            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
            console.log(error);
          });
      }
    }
  }
  closeVideoPlayer(isEmbed) {
    this.unloadVideoPlayer(isEmbed);
  }

  private unloadVideoPlayer(isEmbed?) {
    if (!isEmbed) {
      const player = this.videoplayer ? this.videoplayer.nativeElement : null;
      if (player && typeof player.pause === 'function') {
        player.pause();
        player.currentTime = 0;
      }
    }
    this.videoURL = null;
    this.isEmbed = false;
  }

  toggleVideo(event: any) {
    var myVideo: any = this.videoplayer.nativeElement
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
  }

  pageChanged($event: any) {
    this.filterModel.pageNumber = $event.page;
    this.currentPage = $event.page;
    this.Geti360SpecialReport();
  }
}
